// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { AspNetUser } from './asp-net-user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AspNetUserClaim extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  claimType?: string;
  claimValue?: string;
  userId!: string;
  user!: AspNetUser;
}

